// 단체체험 신청 시스템 타입 정의

export type GroupBookingStatus = 'pending' | 'confirmed' | 'cancelled';
export type DateStatus = 'available' | 'booked' | 'pending' | 'unavailable';
export type GroupType = 'preschool' | 'elementary';
export type TimeSlot = 'morning' | 'afternoon';
export type SlotStatus = 'available' | 'pending' | 'booked';

export const TIME_SLOT_LABELS: Record<TimeSlot, string> = {
  morning: '오전반',
  afternoon: '오후반',
};

export interface ParticipantGroup {
  label: string;    // e.g., "유치원 6세", "초등 3학년"
  count: number;
}

export interface GroupBookingParticipants {
  type: GroupType;
  groups: ParticipantGroup[];
  total_count: number;
}

export interface GroupBooking {
  id: string;
  booking_number: string;
  program_id: string;
  program_name: string;
  booking_dates: string[];
  user_id: string | null;
  institution_name: string;
  institution_phone: string;
  booker_name: string;
  booker_phone: string;
  participants: GroupBookingParticipants;
  time_slot: TimeSlot | null;
  status: GroupBookingStatus;
  admin_memo: string | null;
  created_at: string;
  updated_at: string;
  confirmed_at: string | null;
  cancelled_at: string | null;
}

export interface DateStatusInfo {
  date: string;
  status: DateStatus;
  slots?: Record<TimeSlot, SlotStatus>;  // 시간대 프로그램일 때만
}

// API Request/Response 타입

export interface SubmitGroupBookingRequest {
  program_id: string;
  booking_dates: string[];
  institution_name: string;
  institution_phone: string;
  booker_name: string;
  booker_phone: string;
  participants: GroupBookingParticipants;
  time_slot?: TimeSlot;  // 시간대 프로그램일 때 필수
}

export interface GroupBookingResult {
  booking_id: string;
  booking_number: string;
  status: GroupBookingStatus;
  booking_dates: string[];
  time_slot?: TimeSlot | null;
  institution_name: string;
  booker_name: string;
}

export interface SubmitGroupBookingResponse {
  success: boolean;
  data?: GroupBookingResult;
  error?: {
    code: string;
    message: string;
  };
}

export interface GetGroupAvailableDatesResponse {
  success: boolean;
  data?: {
    dates: DateStatusInfo[];
    use_time_slots?: boolean;
  };
  error?: {
    code: string;
    message: string;
  };
}

export interface AdminUpdateGroupBookingRequest {
  booking_id: string;
  new_status: 'confirmed' | 'cancelled';
  admin_memo?: string;
}

export interface AdminUpdateGroupBookingResponse {
  success: boolean;
  data?: {
    booking_id: string;
    booking_number: string;
    status: string;
    auto_cancelled?: Array<{
      booking_id: string;
      booking_number: string;
      booker_name: string;
      institution_name: string;
    }>;
  };
  error?: {
    code: string;
    message: string;
  };
}

export interface AdminManageGroupDatesRequest {
  program_id: string;
  action: 'add' | 'remove';
  dates: string[];
}

export interface AdminManageGroupDatesResponse {
  success: boolean;
  data?: {
    updated_count: number;
    dates: string[];
  };
  error?: {
    code: string;
    message: string;
  };
}

export interface LookupGroupBookingResponse {
  success: boolean;
  data?: {
    booking_number: string;
    program_name: string;
    booking_dates: string[];
    time_slot?: TimeSlot | null;
    institution_name: string;
    booker_name: string;
    booker_phone: string;
    participants: GroupBookingParticipants;
    status: GroupBookingStatus;
    created_at: string;
    confirmed_at: string | null;
    cancelled_at: string | null;
  };
  error?: {
    code: string;
    message: string;
  };
}
